/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The F1 Fantasy suite is the deepest part of the site, built for Formula 1 Fantasy managers who want a competitive edge every race weekend:`)
};

const es_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El conjunto de F1 Fantasy es la parte más profunda del sitio, creado para managers de Formula 1 Fantasy que quieren una ventaja competitiva cada fin de semana de carrera:`)
};

const de_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die F1-Fantasy-Suite ist der umfangreichste Teil der Seite, entwickelt für Formel-1-Fantasy-Manager, die an jedem Rennwochenende einen Wettbewerbsvorteil suchen:`)
};

const nl_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De F1 Fantasy-suite is het meest uitgebreide onderdeel van de site, gebouwd voor Formule 1 Fantasy-managers die elk raceweekend een competitief voordeel willen:`)
};

const fr_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suite F1 Fantasy est la partie la plus approfondie du site, conçue pour les managers de Fantasy Formule 1 qui veulent un avantage compétitif à chaque week-end de course :`)
};

const it_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suite F1 Fantasy è la parte più approfondita del sito, creata per i manager di Formula 1 Fantasy che vogliono un vantaggio competitivo ad ogni weekend di gara:`)
};

const pt_br2_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conjunto F1 Fantasy é a parte mais completa do site, criado para gestores de Fórmula 1 Fantasy que querem uma vantagem competitiva em cada fim de semana de corrida:`)
};

const pt_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conjunto F1 Fantasy é a parte mais aprofundada do site, criado para gestores de Fórmula 1 Fantasy que querem uma vantagem competitiva em cada fim de semana de corrida:`)
};

const ja_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジースイートはサイトで最も充実した部分であり、毎レースウィークエンドで競争力を求めるFormula 1ファンタジーマネージャーのために構築されています:`)
};

const zh_about_f1_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy 套件是本站内容最深入的部分，专为希望在每个比赛周都占据竞争优势的 F1 Fantasy 车队经理打造：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_f1_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_f1_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_f1_intro", locale)
	if (locale === "en") return en_about_f1_intro(inputs)
	if (locale === "es") return es_about_f1_intro(inputs)
	if (locale === "de") return de_about_f1_intro(inputs)
	if (locale === "nl") return nl_about_f1_intro(inputs)
	if (locale === "fr") return fr_about_f1_intro(inputs)
	if (locale === "it") return it_about_f1_intro(inputs)
	if (locale === "pt-BR") return pt_br2_about_f1_intro(inputs)
	if (locale === "pt") return pt_about_f1_intro(inputs)
	if (locale === "ja") return ja_about_f1_intro(inputs)
	return zh_about_f1_intro(inputs)
};